import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { FolderModel } from '../models/folder.model';
import { Observable, map, of, tap } from 'rxjs';

@Injectable()
export class FolderService {
  private cachedFolders: Map<string, FolderModel>;

  constructor(private api: ApiService) {
    this.cachedFolders = new Map<string, FolderModel>();
  }

  addFolder(path: string, folderName: string): Observable<FolderModel> {
    const addFolder = { fullPath: path, name: folderName };
    return this.api.post('folder/add', addFolder);
  }

  getFolder(folder: FolderModel): Observable<FolderModel> {
    const cachedFolder = this.cachedFolders.get(folder.path);

    if (cachedFolder) {
      return of(cachedFolder);
    } else {
      return this.api
        .post<FolderModel>('folder/get', folder, {
          showToast: true,
        })
        .pipe(
          tap((folder: FolderModel) => {
            this.cacheFolder(folder);
          })
        );
    }
  }
  getAssembledNonCaseFolder(folder: FolderModel): Observable<FolderModel> {
    return this.api
      .post<FolderModel>('folder/GetAssembledNonCase', folder, {
        showToast: true,
      })
      .pipe(tap((folder: FolderModel) => {}));
  }

  deleteCache() {
    this.cachedFolders = new Map<string, FolderModel>();
  }

  private cacheFolder(folder: FolderModel) {
    this.cachedFolders.set(folder.path, folder);
  }
}
